export const BASE_PACKAGE_CODE_KEY = 'Base';
export const DEFAULT_CONTACT_SUPPORT_EMAIL = 'propertyagents@trademe.co.nz';